<template>
  <div id="app">
    <div class="index-page">
      <indexs></indexs>
      
    </div>
  </div>
</template>

<script>
import indexs from "@/components/page/indexs.vue"; //头部
import indexLeft from "@/components/page/indexLeft.vue"; //头部
import indexRight from "@/components/page/indexRight.vue"; //头部

export default {
  name: 'App',
  components: {
    indexs,
    indexLeft,
    indexRight
  },
    data() {


    return {
      // dialogVisible: true,
     
    };
  },
  computed: {
    
  },
  watch: {

    //监听器
	watch: {

	},


  },
  methods: {

  },

}
</script>
<style src='./../static/icon/iconfont.css'></style>
<style>
#app .index-page{
  position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    background: url("./assets/img/444.jpg") no-repeat center center;
}
.lefts{
  position: absolute;
    top: 0;
    width: 480px;
    left: 0;
    bottom: 0;
}
.rights{
    position: absolute;
    top: 0px;
    left: 480px;
    bottom: 0;
    right: 0;
        overflow-y: auto;
}


/* .top{
      position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
}

.content{
  position: absolute;
    top: 80px;
    left: 200px;
    bottom: 0;
    right: 0;
    padding: 10px;
    background: #f6f6f6;

} */
</style>



// WEBPACK FOOTER //
// src/App.vue